export function FileToBase64(inputFile) {
  const temporaryFileReader = new FileReader();
  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort();
      reject(new DOMException("Problem parsing input file."));
    };
    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result);
    };
    temporaryFileReader.readAsDataURL(inputFile);
  });
}

export function RemoveFormatFromBase64(input) {
  try {
    let splited = input.split(',');
    if (splited[1].length > 1) {
      return splited[1];
    }
  } catch (e) {
    new DOMException("Problem spliting Data/DataType");
  }
  return "error";
}

export function AppendFormData(obj, form, namespace) {
  var fd = form || new FormData();
  var formKey;

  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + "[" + property + "]";
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (typeof obj[property] === "object") {
        AppendFormData(obj[property], fd, formKey);
      } else {
        if (typeof obj[property] === "number") {
          fd.append(formKey, obj[property].toString().replace(".", ","));
        } else {
          fd.append(formKey, obj[property]);
        }
      }
    }
  }

  return fd;
}


// WEBPACK FOOTER //
// ./src/utils/fileUtils.js